import { render, staticRenderFns } from "./callsCount.vue?vue&type=template&id=a2bf0fdc&"
import script from "./callsCount.vue?vue&type=script&lang=js&"
export * from "./callsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports